<script lang="ts">
    import { onMount } from 'svelte';
    import { cubicOut } from 'svelte/easing';
    import { tweened } from 'svelte/motion';

    let mouseX = tweened(0, { duration: 500, easing: cubicOut });
    let mouseY = tweened(0, { duration: 500, easing: cubicOut });

    const handleMouseMove = (event: MouseEvent) => {
        if (window.native) return;
        mouseX.set(event.clientX);
        mouseY.set(event.clientY);
    };

    onMount(() => {
        const body = document.querySelector('body');
        body?.addEventListener('mousemove', handleMouseMove, { capture: true });
        return () => {
            body?.removeEventListener('mousemove', handleMouseMove);
        };
    });

    $: style = window.native
        ? `top: 10px; left: 50%; transform: translateX(-50%)`
        : `top: ${$mouseY + 20}px; left: ${$mouseX}px;`;
</script>

<div
    class="pointer-events-none fixed z-[99999999999999999] max-w-xs rounded-xl border-2 border-black bg-red-40 p-sm text-xs text-white"
    {style}
>
    YOU MIGHT NOT BE ON THE MASTER BRANCH
</div>
